import React from 'react';

import SearchBar from './SearchBar'
import Featured from './displayFeatured/Featured'

import { motion } from 'framer-motion'

function Home(props){
    return (
        <div
        className="home">
            <SearchBar />
            <Featured {...props} />
        </div>
    );
}

export default Home;
